/**
 * @fileoverview Default values for image-related entities.
 *
 * NOTE: Please don't import this file directly, but use the index file instead.
 */
import { MiaPlaza } from "@/Reinforced.Typings";
import TransparentAvatarPicture from "@theme/flashlessAvatars/transparent_default.png";
import AvatarPicture from "@theme/flashlessAvatars/default.png";

/**
 * Default aspect ratio for images.
 */
const DefaultAspectRatio = "1/1";

/**
 * Default base64 string for a transparent pixel.
 */
const DefaultTransparentPixelString = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

/**
 * Default base64 string for a transparent SVG.
 */
const DefaultTransparentSvgString = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg==";

/**
 * Default transparent avatar picture.
 */
export const DefaultAvatarPictureTransparent = TransparentAvatarPicture;

/**
 * Default avatar picture with background.
 */
export const DefaultAvatarPictureWithBackground = AvatarPicture;

/**
 * Default url for image.
 */
export const DefaultImageUrl = DefaultTransparentPixelString;

/**
 * Default transparent picture.
 */
export const DefaultPicture = Object.freeze<MiaPlaza.Navigation.JSON.Converters.ILazySizes>({
	AspectRatio: DefaultAspectRatio,
	OriginalUrl: DefaultTransparentPixelString,
	Sizes: [],
});

/**
 * Default transparent SVG picture.
 */
export const DefaultPictureSvg = Object.freeze<MiaPlaza.Navigation.JSON.Converters.ILazySizes>({
	AspectRatio: DefaultAspectRatio,
	OriginalUrl: DefaultTransparentSvgString,
	Sizes: [],
});
